import { IBindableWidgetConfiguration } from '../../widgets';
import { NameBuilderConfiguration, ReprocessingTaskOptionsOverride } from '../../models';

export class SpotManualInputsConfiguration implements IBindableWidgetConfiguration {
    group: string;
    hasLastValue: boolean;
    hasTagName: boolean;
    hasTimeStamp: boolean;
    hasUserComment: boolean;
    hasValue: boolean;
    is2DTable?: boolean;
    isBound?: boolean;
    launchTask: boolean;
    nameConfiguration: NameBuilderConfiguration;
    referenceGroup?: string;
    taskOptionsOverride?: ReprocessingTaskOptionsOverride;

    constructor() {
        this.hasTagName = true;
        this.hasTimeStamp = true;
        this.hasUserComment = true;
        this.hasValue = true;
        this.launchTask = true;
        this.nameConfiguration = new NameBuilderConfiguration();
        this.taskOptionsOverride = { includeDependent: true };
        this.hasLastValue = true;
    }
}